const AudiFonts = `
  // Audi Type Normal
  @font-face {
    font-family: "Audi Type";
    font-style: normal;
    font-weight: normal;
    src: url("https://assets.one.audi/assets/fonts/AudiTypeVF.woff2") format("woff2-variations"),
          url("https://assets.one.audi/assets/fonts/AudiType-Normal.woff2") format("woff2"),
          url("https://assets.one.audi/assets/fonts/AudiType-Normal.woff") format("woff"),
          url("https://assets.one.audi/assets/fonts/AudiType-Normal.ttf") format("truetype");
  }

  // Audi Type Bold
  @font-face {
    font-family: "Audi Type";
    font-style: normal;
    font-weight: 700;
    src: url("https://assets.one.audi/assets/fonts/AudiTypeVF.woff2") format("woff2-variations"),
          url("https://assets.one.audi/assets/fonts/AudiType.woff2") format("woff2"),
          url("https://assets.one.audi/assets/fonts/AudiType.woff") format("woff"),
          url("https://assets.one.audi/assets/fonts/AudiType.ttf") format("truetype");
  }
  
  // Audi Type Italic
  @font-face {
    font-family: "Audi Type";
    font-style: italic;
    font-weight: normal;
    src: url("https://assets.one.audi/assets/fonts/AudiType-Italic.woff2") format("woff2"),
          url("https://assets.one.audi/assets/fonts/AudiType-Italic.woff") format("woff"),
          url("https://assets.one.audi/assets/fonts/AudiType-Italic.ttf") format("truetype");
  }
  
  // Audi Type Bold Italic
  @font-face {
    font-family: "Audi Type";
    font-style: italic;
    font-weight: 700;
    src: url("https://assets.one.audi/assets/fonts/AudiType-BoldItalic.woff2") format("woff2"),
          url("https://assets.one.audi/assets/fonts/AudiType-BoldItalic.woff") format("woff"),
          url("https://assets.one.audi/assets/fonts/AudiType-BoldItalic.ttf") format("truetype");
  }
  
  // Audi Type Extended Normal
  @font-face {
    font-family: "Audi Type Extended";
    font-stretch: 130%;
    font-style: normal;
    font-weight: normal;
    src: url("https://assets.one.audi/assets/fonts/AudiTypeVF.woff2") format("woff2-variations"),
        url("https://assets.one.audi/assets/fonts/AudiType-ExtendedNormal.woff2") format("woff2"),
        url("https://assets.one.audi/assets/fonts/AudiType-ExtendedNormal.woff") format("woff"),
        url("https://assets.one.audi/assets/fonts/AudiType-ExtendedNormal.ttf") format("truetype");
  }
  
  // Audi Type Extended Bold
  @font-face {
    font-family: "Audi Type Extended";
    font-stretch: 130%;
    font-style: normal;
    font-weight: 700;
    src: url("https://assets.one.audi/assets/fonts/AudiTypeVF.woff2") format("woff2-variations"),
        url("https://assets.one.audi/assets/fonts/AudiType-ExtendedBold.woff2") format("woff2"),
        url("https://assets.one.audi/assets/fonts/AudiType-ExtendedBold.woff") format("woff"),
        url("https://assets.one.audi/assets/fonts/AudiType-ExtendedBold.ttf") format("truetype");
  }
  
  // Audi Type Extended Italic
  @font-face {
    font-family: "Audi Type Extended";
    font-stretch: 130%;
    font-style: italic;
    font-weight: normal;
    src: url("https://assets.one.audi/assets/fonts/AudiType-ExtendedItalic.woff2") format("woff2"),
          url("https://assets.one.audi/assets/fonts/AudiType-ExtendedItalic.woff") format("woff"),
          url("https://assets.one.audi/assets/fonts/AudiType-ExtendedItalic.ttf") format("truetype");
  }
  
  // Audi Type Extended Bold Italic
  @font-face {
    font-family: "Audi Type Extended";
    font-stretch: 130%;
    font-style: italic;
    font-weight: 700;
    src: url("https://assets.one.audi/assets/fonts/AudiType-ExtendedBoldItalic.woff2") format("woff2"),
          url("https://assets.one.audi/assets/fonts/AudiType-ExtendedBoldItalic.woff") format("woff"),
          url("https://assets.one.audi/assets/fonts/AudiType-ExtendedBoldItalic.ttf") format("truetype");
  }

  // Audi Type Wide Normal
  @font-face {
    font-family: "Audi Type Wide";
    font-stretch: 105%;
    font-style: normal;
    font-weight: normal;
    src: url("https://assets.one.audi/assets/fonts/AudiTypeVF.woff2") format("woff2-variations"),
        url("https://assets.one.audi/assets/fonts/AudiType-WideNormal.woff2") format("woff2"),
        url("https://assets.one.audi/assets/fonts/AudiType-WideNormal.woff") format("woff"),
        url("https://assets.one.audi/assets/fonts/AudiType-WideNormal.ttf") format("truetype");
  }
  
  // Audi Type Wide Bold
  @font-face {
    font-family: "Audi Type Wide";
    font-stretch: 105%;
    font-style: normal;
    font-weight: 700;
    src: url("https://assets.one.audi/assets/fonts/AudiTypeVF.woff2") format("woff2-variations"),
        url("https://assets.one.audi/assets/fonts/AudiType-WideBold.woff2") format("woff2"),
        url("https://assets.one.audi/assets/fonts/AudiType-WideBold.woff") format("woff");
  }
  
  // Audi Type Wide Light
  @font-face {
    font-family: "Audi Type Wide";
    font-stretch: 105%;
    font-style: normal;
    font-weight: normal;
    src: url("https://assets.one.audi/assets/fonts/AudiType-WideLight.woff2") format("woff2"),
        url("https://assets.one.audi/assets/fonts/AudiType-WideLight.woff") format("woff"),
        url("https://assets.one.audi/assets/fonts/AudiType-WideLight.ttf") format("truetype");
  }

`;

export default AudiFonts;
